import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { FormFeedback } from 'reactstrap';

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.misc.paises.delete}
                postUrl={api.misc.paises.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El País ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar País"}
                buttonTitle={"Eliminar País"}
                buttonIcon={"fa fa-trash fa-lg"}
                saveButton={true}
                closeButton={true}
                danger={true}
                className={"ui-modal-dialog"}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
            >
                <div className="ui-form">
                    <div className="ui-field">
                        <label>Nombre</label>
                        <input type="text" name="nombre" className="form-control" disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/misc/Pais/Delete.js